import { useNavigate } from 'react-router-dom';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';
import { SiLinktree } from "react-icons/si";

function Footer() {
  const navigate = useNavigate();

  return (
    <div className="bg-bleu-footer text-white px-3 py-6 flex flex-col items-center">
      <div className="flex justify-center max-[768px]:flex-col max-[768px]:items-center">
        <button className="bg-white text-bleu-footer w-[300px] h-10 flex items-center justify-center px-12 py-2 mx-[68px] mb-4 cursor-pointer max-[768px]:mx-0 max-[768px]:my-2 max-[768px]:w-[110%]"
          onClick={() => { navigate('/contact'); window.scrollTo(0, 0); }}>
          Faire un devis
        </button>
        <a href="./plaquette/Plaquette_26-27.pdf" target="_blank" rel="noreferrer" className="bg-white text-bleu-footer w-[300px] h-10 flex items-center justify-center px-12 py-2 mx-[68px] mb-4 cursor-pointer max-[768px]:mx-0 max-[768px]:my-2 max-[768px]:w-[110%]">
          Voir la plaquette
        </a>
      </div>

      <div className="text-center my-3">
        <h2 className="mb-5 text-[26px] max-[768px]:text-[22px] max-[480px]:text-[18px]">
          Suivez-nous sur les réseaux sociaux !
        </h2>
        <div className="flex justify-center items-center">
          <a href="https://www.instagram.com/juniori2c" target="_blank" rel="noreferrer" class="mx-[30px] max-[768px]:mx-[15px]">
          <FaInstagram size={64}/>
          <span class="sr-only">Instagram</span>
          </a>
          <a href="https://www.linkedin.com/company/juniori2c" target="_blank" rel="noreferrer" class="mx-[30px] max-[768px]:mx-[15px]">
          <FaLinkedin size={64}/>
          <span class="sr-only">LinkedIn</span>
          </a>
          <a href="https://linktr.ee/juniori2c" target="_blank" rel="noreferrer" class="mx-[30px] max-[768px]:mx-[15px]">
          <SiLinktree size={64}/>
          <span class="sr-only">Linktree</span>
          </a>
        </div>
      </div>

      <div className="flex w-full mt-5 max-[768px]:flex-col max-[768px]:items-center max-[768px]:text-center items-stretch">
        <div className="flex flex-col items-center flex-1 text-center text-[15px] -mt-14 max-[768px]:mt-0 max-[480px]:mt-2 max-[480px]:text-[14px]">
          <embed src="/images/logo_i2c_blanc.svg" type="" className="h-[120px] w-auto max-[768px]:h-[60px] max-[480px]:h-[50px]"/>
          <p>109 Av. Roul, 33400 Talence</p>
          <p>junior-i2c@ensc.fr</p>
        </div>

        <div className="flex-1 flex flex-col justify-start text-center text-[12px] max-[480px]:text-[10px] mt-4 max-[768px]:mt-4">
          <div>
            <p onClick={() => { navigate('/politique-de-confidentialite'); window.scrollTo(0, 0); }} className="mb-1 cursor-pointer hover:underline">Politique de confidentialité</p>
            <p onClick={() => { navigate('/mentions-legales'); window.scrollTo(0, 0); }} className="mb-1 cursor-pointer hover:underline">Mentions légales</p>
            <p onClick={() => { navigate('/cgu'); window.scrollTo(0, 0); }} className="mb-1 cursor-pointer hover:underline">Conditions Générales d’Utilisation (CGU)</p>
          </div>
          <p className="mt-1">@copyright fait par l'équipe i2site</p>
        </div>

        <div className="flex-1 flex flex-col items-center mt-4 max-[768px]:mt-6 space-y-2">
          <button className="bg-gray-800 text-white text-[17px] h-10 w-[200px] flex items-center justify-center" onClick={() => navigate('/espace-membre')}>
            Espace membre
          </button>
          <a href="https://www.google.com/maps/place/Ing%C3%A9nierie+et+Conseil+en+Cognitique+-+i2c/@44.8062908,-0.5994979,17z/data=!4m6!3m5!1s0xd55277c089d51b9:0x4eabdfee1b57debc!8m2!3d44.806287!4d-0.596923!16s%2Fg%2F11hdc4j52t?entry=ttu&g_ep=EgoyMDI1MDcyOC4wIKXMDSoASAFQAw%3D%3D"
            target="_blank" rel="noreferrer" className="bg-gray-800 text-white text-[17px] h-10 w-[200px] flex items-center justify-center rounded hover:opacity-90 transition">
            Notre adresse
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;